export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const USER_LOG_OUT = 'USER_LOG_OUT';

export function userAuthenticated(json) {
    return {
        type: USER_AUTHENTICATED,
        authToken: json.token,
        caps: json.capabilities,
        expires: json.expires,
        identity: json.identity,
    };
}

export function userLogOut() {
    return {
        type: USER_LOG_OUT
    };
}